import * as React from "react";
const SvgStopIcon = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { x: 6, y: 6, width: 12, height: 12, rx: 2, fill: "currentColor" }));
export { SvgStopIcon as ReactComponent };
